import { render, staticRenderFns } from "./RecoveryEmailBySMS.vue?vue&type=template&id=36a965c7"
import script from "./RecoveryEmailBySMS.vue?vue&type=script&lang=js"
export * from "./RecoveryEmailBySMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports